import _ from "lodash";
import axios from "axios";
import { pushAndSetLocale } from "@/landing/plugins/i18n";
import injectables from "@/_shared/lib/meta/injectables";

const injectSchema = [
  {
    injectedDataKey: null,
    action: "setAll",
  },
];

class InitializeApp {
  constructor($store /* , $echo */) {
    this.injectables = injectables;
    this.$store = $store; // Root store
    // this.$echo = $echo; // Root echo
  }

  async handle() {
    /**
     * 1. First lets inject all data or if no data is available, then
     * fetch injectables from single route to load app faster.
     */
    await this.inject();

    /**
     * 2. Most of following dispatches will skip because we have already injected the data,
     * but if something is missing then it will be fetched alacarte.
     *
     * 2.1 First we fetch those that are (more or less)dependancies for other data.
     */
    await this.fetchDependencies();

    /**
     * 2.2 After dependencies are fetched or injected we continue fetching and initializing separate parts of app syncronously. Most dispatches will again just skip.
     */
    await this.fetchAndInitDependables();

    return "OK";
  }

  async inject() {
    if (!this.injectables) {
      this.loading = true;
      try {
        const response = await axios.get("/web-api/app-data");
        this.injectables = _.get(response, "data", {});
      } catch (error) {
        if (_.get(error, ["response", "status"]) === 401)
          this.$store.commit("SET", { authenticated: false });
      }

      /**
       *  On production i18n.js gets injected languages directly from meta
       *  but on development we must inject languages:
       */
      await this.setLocaleFromFetchedInjectables();
    }

    let injectableData;
    for (let [key, item] of Object.entries(injectSchema)) {
      injectableData = _.get(this.injectables, item.injectedDataKey, this.injectables);
      if (!injectableData) continue;
      // console.log("dispatch", item.action, injectableData);
      this.$store.dispatch(item.action, injectableData);
    }
    this.$store.commit("SET", { initialized: true });

    return Promise.resolve();
  }

  async setLocaleFromFetchedInjectables() {
    await pushAndSetLocale(
      this.injectables.lang.locale,
      this.injectables.lang.translations[this.injectables.lang.locale]
    );
    return Promise.resolve();
  }

  async fetchDependencies() {
    const promises = [
      // this.$store.dispatch("fetchUser", true),
      // this.$store.dispatch("fetchEntity", true),
      // this.$store.dispatch("employee/fetch", true)
    ];

    return Promise.allSettled(promises).then(values => {
      Promise.resolve(values);
    });
  }

  async fetchAndInitDependables() {
    const promises = [
      this.$store.dispatch("set", {
        languageOptions: _.get(this.injectables, ["lang", "options"], []),
      }),
    ];

    return Promise.allSettled(promises).then(values => {
      // console.log("values", values);
      Promise.resolve(values);
    });
  }
}

export default InitializeApp;
